import React from "react";
import { classNames } from "../../helpers/classNames";

const LangSwitch = ({
  langs = [],
  selectedLang,
  setSelectedLang = () => {},
}) => {
  return (
    <ul className="flex items-center space-x-1">
      {langs?.map((lang) => (
        <li key={lang}>
          <button
            onClick={() => {
              setSelectedLang(lang);
            }}
            type="button"
            className={classNames(
              "border border-primary bg-white capitalize w-24 py-2 rounded-lg",
              selectedLang === lang ? "bg-primary text-white" : ""
            )}
          >
            {lang}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default LangSwitch;
